import React from 'react';

/**
 * **불러오는 중 표시.**
 *
 * 글자만 "불러오는 중…" 이라고 두면 멈춘 화면과 구별이 안 된다 — 느린 회선에서는 그대로
 * 굳어 버린 것처럼 보인다. 도는 고리를 같이 두면 "아직 오고 있다" 는 것이 한눈에 보인다.
 *
 * 돌리는 애니메이션은 `App.css` 의 `@keyframes spin` 을 쓴다. 화면마다 `<style>` 로 다시
 * 적어 두는 자리가 있었는데, 같은 이름이라 한 번만 있으면 된다.
 *
 * 색과 굵기는 사이트의 보라(#667eea)를 따른다. 크기만 자리에 맞게 바꿔 쓴다.
 */
export default function Loading({
    label = '불러오는 중…',
    size = 28,
    padding = 40,
    color = '#667eea'
}: {
    /** 같이 적을 말. 빈 문자열이면 고리만 돈다 */
    label?: string;
    /** 고리 지름(px) */
    size?: number;
    /** 위아래 여백. 칸 안에 작게 넣을 때는 줄인다 */
    padding?: number | string;
    color?: string;
}) {
    return (
        <div
            role="status"
            aria-label={label || '불러오는 중'}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 10,
                padding,
                color,
                fontSize: Math.max(12, Math.round(size * 0.46)),
                fontWeight: 600
            }}
        >
            <span
                style={{
                    width: size,
                    height: size,
                    borderRadius: '50%',
                    border: `${Math.max(2, Math.round(size / 9))}px solid rgba(102, 126, 234, 0.2)`,
                    borderTopColor: color,
                    animation: 'spin 1s linear infinite',
                    display: 'inline-block',
                    flexShrink: 0
                }}
            />
            {label && <span>{label}</span>}
        </div>
    );
}
